var $f1aa20331d81edcd$exports = {};
$f1aa20331d81edcd$exports = {
    "maximum": `\u{41C}\u{430}\u{43A}\u{441}\u{438}\u{43C}\u{443}\u{43C}`,
    "minimum": `\u{41C}\u{438}\u{43D}\u{438}\u{43C}\u{443}\u{43C}`
};


export {$f1aa20331d81edcd$exports as default};
//# sourceMappingURL=ru-RU.mjs.map
